const styles = theme => ({
    blockContainer: {
        minHeight: "250px",
        backgroundImage: theme.palette.type === 'dark'
            ? 'linear-gradient(145deg, rgba(29, 35, 48, 0.68), rgba(20, 24, 33, 0.64))'
            : 'linear-gradient(145deg, rgba(255, 255, 255, 0.68), rgba(244, 246, 253, 0.64))',
        color: theme.palette.text.primary,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(6),
        marginLeft: theme.spacing(6),
        marginRight: theme.spacing(6),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        borderRadius: theme.spacing(3),
        border: `1px solid ${theme.palette.divider}`,
        backdropFilter: 'blur(14px) saturate(135%)',
        [theme.breakpoints.down('sm')]: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        }
    },
});

export default styles;
